import { render, staticRenderFns } from "./AdTemplatesOverview.vue?vue&type=template&id=c7627bba"
import script from "./AdTemplatesOverview.vue?vue&type=script&lang=js"
export * from "./AdTemplatesOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports